var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlgorandLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46903 20L6.37168 14.9912L9.27434 10L12.1593 4.99118L12.6372 4.19753L12.8496 4.99118L13.7345 8.28924L12.7434 10L9.84071 14.9912L6.95575 20H10.4248L13.3274 14.9912L14.8319 12.3986L15.5398 14.9912L16.885 20H20L18.6549 14.9912L17.3097 10L16.9558 8.71252L19.115 4.99118H15.9646L15.8584 4.62081L14.7611 0.529101L14.6195 0H11.5929L11.5221 0.10582L8.69027 4.99118L5.78761 10L2.90265 14.9912L0 20H3.46903Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgorandLogo);
export default __webpack_public_path__ + "static/media/AlgorandLogo.7472fdd6dd8ec88fb16243658cf481ea.svg";
export { ForwardRef as ReactComponent };